import { $api } from "../api/api";
import $axios from "../api/accessor";

export const PromoCodeServices = {
  async getAllPromocode(url?: string) {
    let response = await $axios
      .get(url || $api("get_Promocode"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async PostPromoCode(payload: any) {
    try {
      const response = await $axios.post($api("post_Promocode"), payload, {
        headers: {
          "Accept-Language": "az",
        },
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
